import * as React from "react";
import Wait from "./wait";

export default class PopDetail extends React.Component{

    static self = null
    constructor(props) {
        super(props)

        PopDetail.self = this

        this.state = {
            title:'Loading...',
            current_pane:<div>Loading...</div>,
        }
    }

    static height = 80
    static show(title_,pane,height=80){
        PopDetail.height = height
        PopDetail.self.setState({
            title:title_,
            current_pane: pane
        })

        document.getElementById('pop_detail').style.display='inherit'
        document.getElementById('div-body').style.height=PopDetail.height+'vh'
    }

    static width = 100
    static showDynamic(title_,pane,height=80, width=100){
        PopDetail.height = height
        PopDetail.width = width
        PopDetail.self.setState({
            title:title_,
            current_pane: pane
        })

        document.getElementById('pop_detail').style.display='inherit'
        document.getElementById('div-body').style.height=PopDetail.height+'vh'
        document.getElementById('div-outer').style.width=PopDetail.width+'vw'
        document.getElementById('div-title').style.textAlign='centre'
        document.getElementById('pop_detail').style.paddingLeft= ((80 - width)/2)+'vw'
    }


    static confirm(title_,description,handler,id,noHandler,height=0){
        if(height===0){
            PopDetail.height = 23
        }else{
            PopDetail.height = height
        }


        let pane = <div style={{textAlign:'center',padding:'16px'}}>
            <h4>{description}</h4>
            <hr/>
            <button onClick={()=>handler(id)} className={'submit'}>Yes</button>
            <button onClick={()=>noHandler()}>No</button>
        </div>
        PopDetail.self.setState({
            title:title_,
            current_pane: pane
        })

        document.getElementById('pop_detail').style.display='inherit'
        document.getElementById('div-body').style.height=PopDetail.height+'vh'
    }


    static showReason(title_,description,handler,action,height=0){
        if(height===0){
            PopDetail.height = 23
        }else{
            PopDetail.height = height
        }


        let pane = <div style={{textAlign:'center',padding:'16px'}}>
            <h4>{description}</h4>
            <hr/>
            <input type={'text'} style={{width: '99%', padding: '8px'}} name={'reason'}/>
            <button onClick={()=>handler(action)} className={'submit'}>Submit</button>
        </div>
        PopDetail.self.setState({
            title:title_,
            current_pane: pane
        })

        document.getElementById('pop_detail').style.display='inherit'
        document.getElementById('div-body').style.height=PopDetail.height+'vh'
    }

    static dismiss(){
        PopDetail.self.setState({
            title:'loading.....',
            current_pane:<div>Loading...</div>
        })
        PopDetail.self.state = null
        document.getElementById('pop_detail').style.display='none'
    }

    static download(path){
        Wait.show('Downloading....')
        const link = document.createElement('a');
        link.href = path;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        Wait.dismiss()


    }

    render() {
        return(<div id={'pop_detail'} style={{verticalAlign:'middle',background:'#fff',zIndex:1001,display:'none',position:'absolute',
            backgroundColor:'#fffa',paddingTop:'6vh',left:0,right:0,textAlign:'center'}}>
            <div style={{height:'100vh',textAlign:'center',width:'100vw'}}>
                <div className={'container'}>

                    <div className={'row'}>
                        <div className={'col col-sm-12'} id={'div-outer'}
                             style={{backgroundColor:'#fff',padding:0,borderRadius:'16px',border:'2px solid #fff',boxShadow:'0 0 100px #888', maxWidth:'800px', margin:'0 auto'}}>
                            <div id={'div-body'} style={{height:'100vh!important',width:'3%',float:'left',
                                borderRadius:'16px 0 0 16px', display: 'none',
                                /*background:'linear-gradient(to top, rgba(0, 0, 0, 0.8),darkcyan,#ff08,darkcyan,darkcyan)'*/
                                backgroundColor:'lightslategray'
                            }}>
                                {/*<img src={map_image} style={{position: "absolute", width: '100%', opacity: '0.1'}}>
                                </img>*/}

                            </div>

                            <div style={{textAlign:'left',width:'100%',top:0,right:0,bottom:0,left:'50px',float:'left'}}>
                                <div id={'div-title'} className={'col col-sm-12'} style={{paddingRight:0,color:'#fff',width:'100%',lineHeight:'40px',height:'40px',
                                    /*backgroundColor:'darkcyan',*/
                                    backgroundColor:'lightslategray',
                                    borderRadius:'16px 16px 0 0'}}>
                                     <span onClick={()=>PopDetail.dismiss()} className={'fa fa-times-circle'}
                                           style={{color:'#fff',cursor:'pointer',fontSize:'20px',margin:'8px'}}/>
                                    <span style={{marginTop:'16px',fontWeight:'bold'}}>
                                        {this.state.title}
                                    </span>

                                </div>
                                <div style={{height:'94%',
                                    overflowY:'auto', padding:'16px',
                                   /* backgroundColor:'#fff',*/
                                    overflowX:'auto'}}>
                                    {this.state.current_pane}
                                </div>
                            </div>


                        </div>
                    </div>



                </div>

            </div>
        </div>)
    }
}